import type { Id } from '../../../aliases'
import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'
import {
  type LookupSiteEncryptionInfo,
  LookupSiteEncryptionInfoSchema,
} from '../../../types/lookupSiteEncryptionInfo'
import {
  type LookupSiteFileHash,
  LookupSiteFileHashSchema,
} from '../../../types/lookupSiteFileHash'
import {
  type OrgSummary,
  OrgSummarySchema,
} from '../../../types/organizationSummary'

export type LookupSiteResponsePayload = {
  siteId: Id
  encryptionInfo?: LookupSiteEncryptionInfo
  currentVersion?: string
  urlPrefix: string
  fileHashes?: LookupSiteFileHash[]
  proxyLinkCode?: Id
  org?: OrgSummary
  requiresAuth?: boolean
  requiresMeshfa?: boolean
  needsSpaceNotifications?: boolean
  needToAcceptOrganizationTos?: boolean
  needsReauth?: boolean
  hasMeshfaClient?: boolean
}

export const LookupSiteResponsePayloadSchema: CborSchema<LookupSiteResponsePayload> =
  defineCborSchema<LookupSiteResponsePayload>({
    siteId: CborField({ key: 0 }),
    encryptionInfo: CborField({
      key: 1,
      required: false,
      type: LookupSiteEncryptionInfoSchema,
    }),
    currentVersion: CborField({ key: 2, required: false }),
    urlPrefix: CborField({ key: 3 }),
    fileHashes: CborField({
      key: 4,
      required: false,
      arrayItemType: LookupSiteFileHashSchema,
    }),
    proxyLinkCode: CborField({ key: 5, required: false }),
    org: CborField({ key: 6, required: false, type: OrgSummarySchema }),
    requiresAuth: CborField({ key: 7, required: false }),
    requiresMeshfa: CborField({ key: 8, required: false }),
    needsSpaceNotifications: CborField({ key: 9, required: false }),
    needToAcceptOrganizationTos: CborField({ key: 10, required: false }),
    needsReauth: CborField({ key: 11, required: false }),
    hasMeshfaClient: CborField({ key: 12, required: false }),
  })
